import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Lingi loomine ebaõnnestus!

  <span style="color:#85c1dc;">**FI:**</span>
  Linkin luominen epäonnistui!

  <span style="color:#85c1dc;">**RU:**</span>
  Не удалось создать ссылку!
*/
/* @__NO_SIDE_EFFECTS__ */
const m1945 = msg(
  mf`Lingi loomine ebaõnnestus!`,
  mf`Linkin luominen epäonnistui!`,
  mf`Не удалось создать ссылку!`,
)

export { m1945 as 'w.wishlist.share.failed' }